export type ButtonProps = {
  id?: string;
  className?: string;
  content: string;
  dataAction?: 'allow' | 'deny' | 'allowAll' | 'denyAll' | 'confirm';
};

const Button = ({ id = undefined, className = '', dataAction = undefined, content }: ButtonProps) => {
  let html = '';
  html += '<button ';
  if (id) {
    html += `id="${id}" `;
  }
  if (dataAction) {
    html += `   data-action="${dataAction}" `;
  }
  html += `   class="ecodigo-ckm-btn ${className}">${content}</button>`;

  return html;
};

export default Button;
